<div class="padding hire">

  <!--  Modal for duplicate employee details -->
  <gp-modal size="lg" gp-modal="employee-detail" [hideHeader]="true" [form]="false" #duplicateModal>
    <div class="gp-modal-body">
      <button class="close-button" (click)="duplicateModal.close()">
        <i class="fa fa-light fa-times"></i>
      </button>
      <gp-employee-form *ngIf="duplicateContract"
                        [contractId]="duplicateContract.id"
                        [readOnly]="true">
      </gp-employee-form>
    </div>
    <div class="gp-modal-footer">
      <button type="button"
              test-id="closeBtn"
              class="btn dark-white p-x-md"
              (click)="duplicateModal.close()">
        {{ 'FORMS.enclose' | translate }}
      </button>
    </div>
  </gp-modal>

  <div *ngIf="contractIdHiredFromMobile; else showWizard" class="info-mobile--landscape white text-center">
    <img alt="under-construction" src="assets/images/illustration_state_under_construction.svg"/>
    <div class="m-t-lg">
      <h4 class="font-weight-bold">{{ 'COMMON.emp_successfully_hired' | translate }}</h4>
      <span>{{ 'COMMON.view_emp_file_in_desktop_mode' | translate }}&nbsp;
        <a [routerLink]="['/employees/files', contractIdHiredFromMobile]">
          <i aria-hidden="true" class="fa-light fa-external-link-alt"></i>
        </a>
      </span>
    </div>
  </div>

  <ng-template #showWizard>
    <div [gp-loading]="creating" *ngIf="!employeeId || selectedEmployee">
      <gp-wizard (done)="finalize()"
                 [submitButtonLabel]="'EMPLOYEE_HIRE.hire' | translate">
        <!-- Step 0 : pay serie and regulation choice -->
        <gp-wizard-step [form]="initialForm"
                        [name]="'EMPLOYEE_HIRE.regulation_payroll_set' | translate">

          <div class="row">
            <div class="col-md-4 col-sm-12">
              <div class="box shadow">
                <div class="box-body">
                  <h6 class="m-b-md">{{ 'EMPLOYEE_HIRE.step_0_regulation_choice' | translate }}</h6>
                  <p>{{ 'EMPLOYEE_HIRE.regulation_choice' | translate }}</p>
                </div>
              </div>

            </div>
            <div class="col-md-8 col-sm-12 withMargin">
              <div class="box card-box shadow">
                <div class="box-header">
                  <h3>{{ 'EMPLOYEE_HIRE.regulation_payroll_set' | translate }}</h3>
                </div>
                <div class="box-body">
                  <!-- Pay serie -->
                  <form [formGroup]="initialForm" autocomplete="off">
                    <div class="form-group">
                      <label for="legalOrganization">
                        {{ paySeriesTitle | translate }}
                        <span class="required">*</span>
                      </label>
                      <div>
                        <gp-tree-select class="form-control"
                                        [tree]="paySeriesTree"
                                        (ngModelChange)="paySerieSelected($event)"
                                        [placeholder]="('EMPLOYEE_HIRE.select' | translate) + ' ' + (paySeriesTitle | translate).toLowerCase()"
                                        formControlName="paySerie"
                                        test-id="legalOrganization"
                                        id="legalOrganization"
                                        ngDefaultControl
                                        [isSorted]="true">
                        </gp-tree-select>
                        <ul class="error-list"
                            [attr.data-hidden]="initialForm.get('paySerie').valid || initialForm.get('paySerie').pristine">
                          <li *ngIf="initialForm.get('paySerie').hasError('prohibited_value')">
                            {{ 'ERROR.prohibited_value' | translate }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="regulation">
                        {{ 'EMPLOYEE_HIRE.regulation' | translate }} <span class="required">*</span>
                      </label>
                      <gp-tree-select class="form-control"
                                      [tree]="regulationTree"
                                      (ngModelChange)="regulationSelected($event)"
                                      [placeholder]="'EMPLOYEE_HIRE.select_regulation' | translate"
                                      formControlName="regulation"
                                      test-id="regulation"
                                      id="regulation"
                                      ngDefaultControl
                                      [readOnly]="!selectedPaySerieId"
                                      [isSorted]="true">
                      </gp-tree-select>
                      <ul class="error-list"
                          [attr.data-hidden]="initialForm.controls.regulation.valid || initialForm.controls.regulation.pristine">
                      </ul>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </gp-wizard-step>

        <!-- Step 1 : Personal information -->
        <gp-wizard-step [form]="infoForm"
                        [name]="'EMPLOYEE_HIRE.personal_information' | translate"
                        *ngIf="!employeeId">


          <div class="row">
            <div class="col-md-4 col-sm-12">
              <div class="box shadow">
                <div class="box-body">
                  <h6 class="m-b-md">{{ 'EMPLOYEE_HIRE.step_2_personal_information' | translate }}</h6>
                  <p>{{ 'EMPLOYEE_HIRE.basic_info' | translate }}</p>
                  <p>{{ 'EMPLOYEE_HIRE.already_exist' | translate }}</p>
                </div>
              </div>

            </div>
            <div class="col-md-8 col-sm-12 withMargin">
              <div class="box card-box shadow">
                <div class="box-header">
                  <h3>{{ 'EMPLOYEE_HIRE.civil_status' | translate }}</h3>
                </div>
                <div class="box-body">
                  <form [formGroup]="infoForm" autocomplete="off">
                    <div formGroupName="number">
                      <div class="row">
                        <!-- Registration number -->
                        <div class="col-md-6">
                          <div for="number" class="col-md-12 reset-padding">
                            {{ 'EMPLOYEE_HIRE.employee_number' | translate }}
                            <span *ngIf="!registrationNumberAuto" class="required">*</span>
                          </div>
                          <div class="col-md-12 reset-padding reg-number">
                            <div for="registrationNumberAuto"
                                 class="d-inline-block contract-id-checkbox pull-left no-padding checkbox">
                              <input id="registrationNumberAuto"
                                     test-id="registrationCheck"
                                     type="checkbox"
                                     formControlName="auto"
                                     [(ngModel)]="registrationNumberAuto"
                                     (ngModelChange)="onChangeAutoNumber($event, infoForm.get('number').get('number'))">
                              {{ 'EMPLOYEE_HIRE.auto' | translate }}
                            </div>
                            <div class="reset-padding reg-panel">
                              <input type="text" class="form-control" formControlName="number" id="number">
                              <em *ngIf="employeeIdValidation" class="fa fa-light fa-spinner fa-spin"></em>
                            </div>
                          </div>
                        </div>
                      </div>
                      <ul class="error-list" [attr.data-hidden]="numberGroup.pristine || numberGroup.valid">
                        <li *ngIf="numberGroup.errors?.valueMissing">
                          {{ 'EMPLOYEE_HIRE.employee_number_mandatory' | translate }}
                        </li>
                        <li *ngIf="infoForm.get('number').hasError('prohibited_value')">
                          {{ 'ERROR.prohibited_value' | translate }}
                        </li>
                        <li *ngIf="infoForm.get('number').get('number').hasError('id_exists')">
                          {{ 'ERROR.employee_id_exists' | translate }}
                        </li>
                      </ul>
                    </div>
                    <div class="row" *ngIf="missingForceRequiredZones">
                      <div class="col-md-12">
                        <ul class="error-list">
                          <li>
                            {{ 'EMPLOYEE_HIRE.cli_emp_zones_not_found' | translate }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <gp-generated-simple-form
                          [groupZoneDescriptor]="cliEmpL1GroupZoneDescriptor"
                          [values]="cliEmpL1ZoneValues"
                          [nbCol]="3"
                          [setDefaultTodayForDate]="false"
                          (formValuesChanged)="onCliEmpFormValuesChanged($event)">
                        </gp-generated-simple-form>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <gp-generated-simple-form
                          #cliEmpL2Form
                          [groupZoneDescriptor]="cliEmpL2GroupZoneDescriptor"
                          [values]="cliEmpL2ZoneValues"
                          [nbCol]="3"
                          [setDefaultTodayForDate]="false"
                          (formValuesChanged)="onCliEmpFormValuesChanged($event)">
                        </gp-generated-simple-form>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="box card-box shadow">
                <div class="box-header">
                  <h3>
                    <i *ngIf="duplicates?.length" aria-hidden="true" class="fa fa-light fa-exclamation-triangle"></i>
                    {{ 'EMPLOYEE_HIRE.possible_duplicate_file' | translate }}
                  </h3>
                </div>
                <div class="box-body table-responsive">
                  <table *ngIf="!loadingDuplicates && duplicates?.length"
                         aria-describedby="duplicates"
                         class="table table-striped table-sm">
                    <thead>
                    <tr>
                      <th scope="col">{{ 'FORMS.first_name' | translate }}</th>
                      <th scope="col">{{ 'FORMS.last_name' | translate }}</th>
                      <th scope="col">{{ 'EMPLOYEE_HIRE.maiden_name' | translate }}</th>
                      <th scope="col">{{ 'EMPLOYEE_HIRE.social_security_number' | translate }}</th>
                      <th scope="col">{{ 'EMPLOYEE_HIRE.has_ongoing_contract' | translate }}</th>
                      <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody test-id="checkDuplicates">
                    <tr *ngFor="let duplicate of duplicates">
                      <td>{{ duplicate.firstName }}</td>
                      <td>{{ duplicate.lastName }}</td>
                      <td>{{ duplicate.maidenName }}</td>
                      <td>{{ duplicate.nationalId }}</td>
                      <td class="text-center">
                        <i *ngIf="duplicate.hasOngoingContract" class="fa fa-light fa-check" aria-hidden="true"></i>
                      </td>
                      <td>
                        <div class="pull-right nowrap" layout="row">
                          <div class="tooltip-wrapper"
                               [tooltip]="duplicate.confidential && duplicate.paySerie ?
                                      ('EMPLOYEE_HIRE.employee_more_info' | translate: { paySerieName: duplicate.paySerie.attributes.transid | translate })
                                      : ''"
                               container="body">
                            <button test-id="eye"
                                    *ngIf="employeeFileEnabled"
                                    class="btn btn-xs btn-icon white"
                                    (click)="openDuplicateDetails(duplicate)"
                                    [disabled]="duplicate.confidential || isMobileDevice">
                              <em class="far fa-eye"></em>
                            </button>
                          </div>
                          <button (click)="toggleSelectEmployee(duplicate)"
                                  [ngClass]="{
                                        'active': selectedEmployee?.id === duplicate.id,
                                        'inactive': selectedEmployee?.id !== duplicate.id
                                      }"
                                  class="btn btn-xs btn-outline-primary"
                                  [attr.test-id]="'hire-first-step-select-' + duplicate.firstName + '-' + duplicate.lastName + '-btn'">
                            {{ 'EMPLOYEE_HIRE.select' | translate }}
                          </button>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div *ngIf="!loadingDuplicates && !duplicates?.length">
                    <p>{{ 'EMPLOYEE_HIRE.no_duplicate_files_found' | translate }}</p>
                  </div>
                  <div *ngIf="loadingDuplicates" class="skeleton p-x-sm">
                    <p>
                      <skeleton-block [effect]="'wave'" borderRadius="4" height="40px" width="100%"></skeleton-block>
                    </p>
                    <p>
                      <skeleton-block [effect]="'wave'" borderRadius="4" height="40px" width="100%"></skeleton-block>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </gp-wizard-step>

        <!-- Step 2 : Contract information -->
        <gp-wizard-step [name]="'EMPLOYEE_HIRE.contract_information' | translate"
                        [form]="infoAndContractForm">
          <div class="row">
            <div class="col-md-4 col-sm-12">
              <div class="box shadow">
                <div class="box-body">
                  <h6
                    class="m-b-md">{{ 'EMPLOYEE_HIRE.step_contract_information' | translate: {step: wizard?.currentStepIndex + 1} }}</h6>
                  <p>{{ 'EMPLOYEE_HIRE.fill_contract_payroll' | translate }}</p>
                  <p>{{ 'EMPLOYEE_HIRE.complete_employee_file' | translate }}</p>
                </div>
              </div>
            </div>
            <div class="col-md-8 col-sm-12 withMargin">
              <div class="box card-box shadow">
                <div class="box-header">
                  <h3>{{ 'EMPLOYEE_HIRE.contract_information' | translate }}</h3>
                </div>
                <div class="box-body">
                  <form [formGroup]="contractForm">
                    <div class="row">
                      <div class="col-md-6">
                        <!-- Begin date -->
                        <div class="form-group">
                          <label for="beginDate">{{ 'FORMS.begin_date' | translate }} <span
                            class="required">*</span></label>
                          <datepicker-input formControlName="beginDate"
                                            id="beginDate"
                                            required
                                            ngDefaultControl>
                          </datepicker-input>
                          <ul class="error-list"
                              [attr.data-hidden]="contractForm.get('beginDate').valid || contractForm.get('beginDate').pristine">
                            <li *ngIf="contractForm.get('beginDate').hasError('prohibited_value')">
                              {{ 'ERROR.prohibited_value' | translate }}
                            </li>
                          </ul>
                        </div>

                        <!-- Contract ID -->
                        <div class="form-group" formGroupName="contractId">

                          <div class="row">
                            <div class="col-md-12">
                              <label for="contractId">
                                {{ 'EMPLOYEE_HIRE.contract_number' | translate }}
                                <span *ngIf="!contractIdAuto" class="required">*</span>
                              </label>
                            </div>
                            <div class="col-md-12">
                              <div for="contractIdAuto" class="contract-id-checkbox checkbox col-md-3">
                                <input tabindex="-1"
                                       type="checkbox"
                                       formControlName="auto"
                                       name="auto"
                                       test-id="contractIdAuto"
                                       id="contractIdAuto"
                                       [(ngModel)]="contractIdAuto"
                                       (ngModelChange)="onChangeAutoNumber($event, contractForm.get('contractId').get('contractId'))">
                                {{ 'EMPLOYEE_HIRE.auto' | translate }}
                              </div>
                              <div class="col-md-9">
                                <input type="text" class="form-control" formControlName="contractId" id="contractId">
                                <em *ngIf="contractIdValidation" class="fa fa-light fa-spinner fa-spin"></em>
                              </div>
                            </div>
                          </div>
                          <ul class="error-list"
                              [attr.data-hidden]="contractIdGroup?.pristine || contractIdGroup?.valid">
                            <li *ngIf="contractIdGroup.hasError('valueMissing')">
                              {{ 'EMPLOYEE_HIRE.contract_number_is_mandatory_when_auto_is_not_checked' | translate }}
                            </li>
                            <li *ngIf="contractForm.get('contractId').hasError('prohibited_value')">
                              {{ 'ERROR.prohibited_value' | translate }}
                            </li>
                            <li *ngIf="contractForm.get('contractId').get('contractId').hasError('id_exists')">
                              {{ 'ERROR.contract_id_exists' | translate }}
                            </li>
                          </ul>
                        </div>

                        <!-- Pay serie -->
                        <div class="form-group">
                          <label for="legalOrganization">
                            {{ paySeriesTitle | translate }}
                            <span class="required">*</span>
                          </label>
                          <div>
                            <gp-tree-select class="form-control"
                                            [tree]="paySeriesTree"
                                            [placeholder]="('EMPLOYEE_HIRE.select' | translate) + ' ' + (paySeriesTitle | translate).toLowerCase()"
                                            formControlName="paySerie"
                                            test-id="legalOrganization"
                                            id="readonlyLegalOrgnaization"
                                            ngDefaultControl
                                            [isSorted]="true"
                                            [readOnly]="true">
                            </gp-tree-select>
                            <ul class="error-list"
                                [attr.data-hidden]="contractForm.get('paySerie').valid || contractForm.get('paySerie').pristine">
                              <li *ngIf="contractForm.get('paySerie').hasError('prohibited_value')">
                                {{ 'ERROR.prohibited_value' | translate }}
                              </li>
                            </ul>
                          </div>
                        </div>

                      </div>

                      <div class="col-md-6">
                        <!-- Forecasted End date -->
                        <div class="form-group">
                          <label for="forecastedEndDate">{{ 'FORMS.forecasted_end_date' | translate }}</label>
                          <datepicker-input formControlName="forecastedEndDate"
                                            id="forecastedEndDate"
                                            ngDefaultControl>
                          </datepicker-input>
                          <ul class="error-list"
                              [attr.data-hidden]="contractForm.valid || contractForm.pristine">
                            <li *ngIf="contractForm.errors?.beginAfterEnd">
                              {{ 'FORMS.ERRORS.dated-block-add-begin-after-forecasted-end-date' | translate }}
                            </li>
                            <li *ngIf="contractForm.get('forecastedEndDate').hasError('prohibited_value')">
                              {{ 'ERROR.prohibited_value' | translate }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <gp-hire-additional-contract-information
                #hireAdditionalContractInformationComponent
                [mssHireEnabled]="!employeeFileEnabled"
                [regulationForm]="regulationForm"
                [paySerieId]="selectedPaySerieId"
                (fieldsChange)="fieldsChange($event)"
                (regulationChange)="regulationChange($event)"
                [regulationReadOnly]="true">
              </gp-hire-additional-contract-information>

              <ng-container *ngIf="employeeFileEnabled">
                <gp-hire-options-copy *ngIf="selectedEmployee"
                                      [optionToCopyForm]="optionToCopyForm"
                                      [selectedEmployee]="selectedEmployee"
                                      [cliRegId]="selectedCliRegId"
                                      [contracts]="contracts">
                </gp-hire-options-copy>
                <gp-hire-employee-model *ngIf="!selectedEmployee"
                                        [cliRegId]="selectedCliRegId"
                                        [employeeModelForm]="employeeModelForm">
                </gp-hire-employee-model>
              </ng-container>

            </div>
          </div>
        </gp-wizard-step>

        <gp-wizard-step [name]="'EMPLOYEE_HIRE.validation' | translate">
          <div class="row">
            <div class="col-md-4 col-sm-12">
              <div class="box shadow">
                <div class="box-body">
                  <h6
                    class="m-b-md">{{ 'EMPLOYEE_HIRE.step_validate' | translate:  {step: wizard?.currentStepIndex + 1} }}</h6>
                  <p>{{ 'EMPLOYEE_HIRE.review_data' | translate }}</p>
                  <p>{{ 'EMPLOYEE_HIRE.validate_the_hiring_of_this_employee' | translate }}</p>
                </div>
              </div>

            </div>
            <div class="col-md-8 col-sm-12 withMargin">
              <div class="box card-box shadow">
                <div class="box-header">
                  <h3>{{ 'EMPLOYEE_HIRE.new_contract_information' | translate }}</h3>
                </div>
                <div class="box-body">
                  <div *ngIf="!selectedEmployee else selectedEmployeeInfos">
                    <div class="row p-y-sm">
                      <div class="col-md-6 text-md-right p-r-md">
                        <strong>{{ 'EMPLOYEE_HIRE.employee_number' | translate }}</strong>
                      </div>
                      <div class="col-md-6" test-id="registrationNumber">
                        {{ infoForm.controls.number['controls'].number.value || 'Auto' }}
                      </div>
                    </div>
                    <div class="row p-y-sm" *ngIf="infoForm.controls.firstName.value">
                      <div class="col-md-6 text-md-right p-r-md">
                        <strong>{{ 'FORMS.first_name' | translate }}</strong>
                      </div>
                      <div class="col-md-6" test-id="firstName"> {{ infoForm.controls.firstName.value }}</div>
                    </div>

                    <div class="row p-y-sm" *ngIf="infoForm.controls.lastName.value">
                      <div class="col-md-6 text-md-right p-r-md">
                        <strong>{{ 'FORMS.last_name' | translate }}</strong>
                      </div>
                      <div class="col-md-6" test-id="lastName">{{ infoForm.controls.lastName.value }}</div>
                    </div>

                    <div class="row p-y-sm" *ngIf="infoForm.controls.maidenName.value">
                      <div class="col-md-6 text-md-right p-r-md">
                        <strong>{{ 'EMPLOYEE_HIRE.maiden_name' | translate }}</strong>
                      </div>
                      <div class="col-md-6" test-id="maidenName">{{ infoForm.controls.maidenName.value }}</div>
                    </div>

                    <div class="row p-y-sm" *ngIf="infoForm.controls.email.value">
                      <div class="col-md-6 text-md-right p-r-md">
                        <strong>{{ 'EMPLOYEE_HIRE.personal_email' | translate }}</strong>
                      </div>
                      <div class="col-md-6" test-id="email">{{ infoForm.controls.email.value }}</div>
                    </div>

                    <div class="row p-y-sm" *ngIf="infoForm.controls.dob.value">
                      <div class="col-md-6 text-md-right p-r-md">
                        <strong>{{ 'EMPLOYEE_HIRE.birth_date' | translate }}</strong>
                      </div>
                      <div class="col-md-6" test-id="birthDate">{{ infoForm.controls.dob.value | gpDate }}</div>
                    </div>

                    <div class="row p-y-sm" *ngIf="infoForm.controls.ssn.value">
                      <div class="col-md-6 text-md-right p-r-md">
                        <strong>{{ 'EMPLOYEE_HIRE.social_security_number' | translate }}</strong>
                      </div>
                      <div class="col-md-6" test-id="socialSecurityNumber">{{ infoForm.controls.ssn.value }}</div>
                    </div>
                  </div>

                  <ng-template #selectedEmployeeInfos>
                    <div class="row p-y-sm">
                      <div class="col-md-6 text-md-right p-r-md">
                        <strong>{{ 'EMPLOYEE_HIRE.employee_number' | translate }}</strong>
                      </div>
                      <div class="col-md-6" test-id="registrationNumber">
                        {{ selectedEmployee?.otherid1 || 'Auto' }}
                      </div>
                    </div>
                    <div class="row p-y-sm" *ngIf="selectedEmployee.firstName">
                      <div class="col-md-6 text-md-right p-r-md">
                        <strong>{{ 'FORMS.first_name' | translate }}</strong>
                      </div>
                      <div class="col-md-6" test-id="firstName"> {{ selectedEmployee.firstName }}</div>
                    </div>

                    <div class="row p-y-sm" *ngIf="selectedEmployee.lastName">
                      <div class="col-md-6 text-md-right p-r-md">
                        <strong>{{ 'FORMS.last_name' | translate }}</strong>
                      </div>
                      <div class="col-md-6" test-id="lastName">{{ selectedEmployee.lastName }}</div>
                    </div>

                    <div class="row p-y-sm" *ngIf="selectedEmployee.maidenName">
                      <div class="col-md-6 text-md-right p-r-md">
                        <strong>{{ 'EMPLOYEE_HIRE.maiden_name' | translate }}</strong>
                      </div>
                      <div class="col-md-6" test-id="maidenName">{{ selectedEmployee.maidenName }}</div>
                    </div>

                    <div class="row p-y-sm" *ngIf="selectedEmployee.email">
                      <div class="col-md-6 text-md-right p-r-md">
                        <strong>{{ 'EMPLOYEE_HIRE.personal_email' | translate }}</strong>
                      </div>
                      <div class="col-md-6" test-id="email">{{ selectedEmployee.email }}</div>
                    </div>

                    <div class="row p-y-sm" *ngIf="selectedEmployee.dob">
                      <div class="col-md-6 text-md-right p-r-md">
                        <strong>{{ 'EMPLOYEE_HIRE.birth_date' | translate }}</strong>
                      </div>
                      <div class="col-md-6" test-id="birthDate">{{ selectedEmployee.dob | gpDate }}</div>
                    </div>

                    <div class="row p-y-sm" *ngIf="selectedEmployee.nationalId">
                      <div class="col-md-6 text-md-right p-r-md">
                        <strong>{{ 'EMPLOYEE_HIRE.social_security_number' | translate }}</strong>
                      </div>
                      <div class="col-md-6" test-id="socialSecurityNumber">{{ selectedEmployee.nationalId }}</div>
                    </div>
                  </ng-template>

                  <div class="row p-y-sm" *ngIf="contractForm.controls.beginDate.value">
                    <div class="col-md-6 text-md-right p-r-md">
                      <strong>{{ 'FORMS.begin_date' | translate }}</strong>
                    </div>
                    <div class="col-md-6" test-id="beginDate">{{ contractForm.controls.beginDate.value | gpDate }}</div>
                  </div>

                  <div class="row p-y-sm" *ngIf="contractForm.controls.forecastedEndDate.value">
                    <div class="col-md-6 text-md-right p-r-md">
                      <strong>{{ 'FORMS.forecasted_end_date' | translate }}</strong>
                    </div>
                    <div class="col-md-6"
                         test-id="forecastedEndDate">{{ contractForm.controls.forecastedEndDate.value | gpDate }}
                    </div>
                  </div>
                  <div class="row p-y-sm">
                    <div class="col-md-6 text-md-right p-r-md">
                      <strong>{{ 'EMPLOYEE_HIRE.contract_number' | translate }}</strong>
                    </div>
                    <div class="col-md-6" test-id="contractID">
                      {{ contractForm['controls'].contractId['controls'].contractId.value || 'Auto' }}
                    </div>
                  </div>

                  <div class="row p-y-sm" *ngIf="hireAdditionalContractInformationComponent.selectedRegulationNickName">
                    <div class="col-md-6 text-md-right p-r-md">
                      <strong>{{ 'EMPLOYEE_HIRE.regulation' | translate }}</strong>
                    </div>
                    <div class="col-md-6"
                         test-id="regulation">{{ hireAdditionalContractInformationComponent.selectedRegulationNickName }}
                    </div>
                  </div>

                  <div class="row p-y-sm" *ngIf="selectedPaySerieValue">
                    <div class="col-md-6 text-md-right p-r-md">
                      <strong>{{ paySeriesTitle | translate }}</strong>
                    </div>
                    <div class="col-md-6" test-id="legalOrganization">{{ selectedPaySerieValue }}</div>
                  </div>

                  <div class="row p-y-sm" *ngFor="let selectedOption of selectedEmpModelOptions">
                    <div class="col-md-6 text-md-right p-r-md">
                      <strong
                        [attr.test-id]="'hire-summary-family-' + selectedOption.familyName + '-label'">{{ selectedOption.familyTransId | translate }}</strong>
                    </div>
                    <div [attr.test-id]="'hire-summary-family-' + selectedOption.familyName + '-value'"
                         class="col-md-6">{{ selectedOption.transId | translate }}
                    </div>
                  </div>

                  <div class="row p-y-sm"
                       *ngFor="let summaryItem of hireAdditionalContractInformationComponent.summary()">
                    <div class="col-md-6 text-md-right p-r-md">
                      <strong>{{ summaryItem.zoneTransId | translate }}</strong>
                    </div>
                    <div class="col-md-6"
                         [attr.test-id]="'additional-' + summaryItem.zoneName">{{ summaryItem.zoneValue | translate }}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </gp-wizard-step>
      </gp-wizard>
    </div>
  </ng-template>
</div>
